export interface HeroContent {
	title: string;
	titleHighlight: string;
	subtitle: string;
	button: string;
}

export const heroContent: HeroContent = {
	title: "SEU ANO FOI",
	titleHighlight: "ÉPICO",
	subtitle: "Retrospectiva {{year}}",
	button: "Começar a Jornada",
};
